import SubscriptionLink from './SubscriptionLink.component';

export default SubscriptionLink;